import React, { useState, useEffect, useContext } from 'react';
import api from '../../utils/api';
import AuthContext from '../../context/AuthContext';
import './ZelleIdSetup.css';

const ZelleIdSetup = () => {
  const { user } = useContext(AuthContext);
  const [zelleId, setZelleId] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '' });

  // Fetch current Zelle ID if exists
  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const res = await api.get('/api/users/me');
        if (res.data.zelleId) {
          setZelleId(res.data.zelleId);
        }
      } catch (err) {
        console.error('Error fetching profile:', err.response?.data || err.message);
        setMessage({
          text: 'Failed to load your Zelle setup. Please try again later.',
          type: 'error'
        });
      }
    };

    fetchUserProfile();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!zelleId.trim()) {
      setMessage({ text: 'Please enter your Zelle ID', type: 'error' });
      return;
    }
    
    setLoading(true);
    
    try {
      const response = await api.put('/api/users/profile', { zelleId });
      
      setMessage({ 
        text: 'Zelle ID updated successfully', 
        type: 'success' 
      });
      
      // Update the local state with the new Zelle ID
      setZelleId(zelleId.trim());
    } catch (err) {
      console.error('Error updating Zelle ID:', err);
      setMessage({ 
        text: err.response?.data?.message || 'Error updating Zelle ID', 
        type: 'error' 
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="zelle-id-setup">
      <h3>Zelle Payment Setup</h3>
      
      <div className="current-setup-info">
        {zelleId ? (
          <div className="setup-status success">
            <span className="checkmark">✓</span>
            <span>Zelle Payment Setup Active</span>
          </div>
        ) : (
          <div className="setup-status">
            <span>Zelle Payment Not Set Up</span>
          </div>
        )}
      </div>
      
      <p className="info-text">
        {zelleId 
          ? 'Your Zelle payment setup is active. Update your Zelle ID below if needed.'
          : 'Enter your Zelle ID to receive payments from candidates. This will be shown to candidates when they need to make a payment.'}
      </p>
      
      {message.text && (
        <div className={`message ${message.type}`}>
          {message.text}
        </div>
      )}
      
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="zelleId">Zelle ID (email or phone number)</label>
          <input
            type="text"
            id="zelleId"
            value={zelleId}
            onChange={(e) => setZelleId(e.target.value)}
            placeholder="Enter your Zelle ID (email or phone number)"
          />
          <p className="help-text">
            Make sure this matches the email or phone number registered with your Zelle account.
          </p>
        </div>
        
        <button 
          type="submit" 
          className="submit-button"
          disabled={loading}
        >
          {loading ? 'Saving...' : 'Save Zelle ID'}
        </button>
      </form>
      
      <div className="payment-instructions">
        <h4>How Zelle Payments Work</h4>
        <ol>
          <li>Enter the email or phone number associated with your Zelle account</li>
          <li>Candidates will see this information when making payments</li>
          <li>You'll receive payments directly to your bank account</li>
          <li>There is 15% S30 mocks platform fee for every interview conducted</li>
        </ol>
      </div>
    </div>
  );
};

export default ZelleIdSetup;
